// @flow

import React, { type ComponentType } from "react";
import { Link } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu } from "..";
import "./navigation-menu.style.scss";

export type NavigationMenuItemType = $Exact<{
  permissionId: string,
  title: string,
  path: string,
  sectionPath: string,
  icon: ComponentType<*>,
  backgroundColor?: string,
  color: string,
}>;

type Props = $Exact<{
  currentPath: string,
  menu: Array<NavigationMenuItemType[]>,
  className: string,
}>;

type State = $Exact<{
  dropdownOpen: boolean,
}>;

export class NavigationMenu extends React.Component<Props, State> {
  state = {
    dropdownOpen: false,
  };

  get activeSection(): NavigationMenuItemType | null {
    if (!this.props.menu.length) {
      return null;
    }

    return (
      [].concat
        .apply([], this.props.menu)
        .find(i => this.props.currentPath.startsWith(i.sectionPath)) || null
    );
  }

  toggle = () => {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  };

  render() {
    const active = this.activeSection;

    return (
      <Dropdown
        isOpen={this.state.dropdownOpen}
        toggle={this.toggle}
        className={`navigation-menu ${this.props.className}`}
      >
        {active ? (
          <DropdownToggle
            color="none"
            caret
            className={`pl-0 text-${active && active.color ? active.color : "teal"}`}
          >
            {active.title}
          </DropdownToggle>
        ) : null}
        <DropdownMenu className="py-4 px-3">
          {this.props.menu.map((menu: NavigationMenuItemType[], m: number) => {
            return menu.map((item: NavigationMenuItemType, i: number) => {
              const { icon: MenuIcon } = item;
              const color = item.color || "teal";
              const isActive = active && active.title === item.title;

              return (
                <React.Fragment key={item.title}>
                  {m > 0 && i === 0 ? <hr className="appmenu-divider mt-2 mb-1" /> : null}
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`mobile-nav-link link ${isActive ? "active" : ""}`}
                    style={{
                      backgroundColor: isActive ? item.backgroundColor : "unset",
                    }}
                  >
                    <div className="navigation-menu__icon">
                      <MenuIcon color="white" className="appmenu-icon" />
                    </div>
                    <span className={`text-${color}`}>{item.title}</span>
                  </Link>
                </React.Fragment>
              );
            });
          })}
        </DropdownMenu>
      </Dropdown>
    );
  }
}

export default NavigationMenu;
